export const STEPS = [
  {
    number: 1,
    title: "Upload Package",
    description: "Select and upload update archive"
  },
  {
    number: 2,
    title: "Review Contents",
    description: "Review package contents"
  },
  {
    number: 3,
    title: "Import Settings",
    description: "Configure and import"
  }
]

export const FILE_MODES = [
  {
    value: "REPLACE",
    label: "Replace",
    description: "Replace existing files with new ones",
  },
  {
    value: "SKIP",
    label: "Skip",
    description: "Skip files that already exist",
  },
  {
    value: "MIRROR",
    label: "Mirror",
    description: "Make destination exactly match source",
  },
]

export const DB_MODES = [
  {
    value: "REPLACE",
    label: "Replace",
    description: "Replace existing documents with the same _id",
  },
  {
    value: "SKIP",
    label: "Skip",
    description: "Skip existing documents with the same _id",
  },
  {
    value: "UPDATE",
    label: "Update",
    description: "Update existing documents with the same _id",
  },
  {
    value: "MERGE",
    label: "Merge",
    description: "Merge new fields into existing documents",
  },
]
